const Resources = {

    table_headers: [
        { 
          text: 'Room Usage',
          align: 'start',
          value: 'room_usage'
        },
        { 
            text: 'Vacant Bed Adjustment',
            value: 'vacant_bed'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Vacant Bed Adjustment',
            href:   '/options-vacant-bed-adjustme',
            arrow:  "",
        },
    ],

}

export default Resources;